import { render, staticRenderFns } from "./Liandong.vue?vue&type=template&id=3946a688&"
import script from "./Liandong.vue?vue&type=script&lang=js&"
export * from "./Liandong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports